import { ChackImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetTestimonials =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.testimonials.get;

      const response = await PostFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const SearchClients =
  ({ callback, search }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.clients.search;

      const data = {
        search,
      };

      const response = await PostFunction({
        data,
        Route: link,
        showalert: false,
        // The list says a failed load itself, with Try again.
        showerror: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });

      callback(response);
    } catch (err) {
      callback(false);
    }
  };
// One page of customers. The API filters (show: all | real | test |
// with_applications), sorts and searches them, finds one by id (the
// customer's own link) and gives every match for the CSV export
// (clients_controller.js); an older API pages them only.
export const GetClients =
  ({ callback, page, rowsPerPage, search, show, sort, id, exportAll }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.clients.get;

      const data = {
        page,
        rowsPerPage,
        ...(search ? { search } : {}),
        ...(show && show !== "all" ? { show } : {}),
        ...(sort ? { sort } : {}),
        ...(id ? { id } : {}),
        ...(exportAll ? { export: true } : {}),
      };

      const response = await PostFunction({
        data,
        Route: link,
        showalert: false,
        // The list says a failed load itself, with Try again.
        showerror: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

// Marks customers as test accounts, or not (API migration 025). The page
// says what happened, and what failed, in its own words.
export const SetTestAccounts = ({ ids, isTest }) => async (dispatch, getState) =>
  PostFunction({
    data: { ids, is_test: !!isTest },
    Route: "clients/test",
    showalert: false,
    showerror: false,
    state: getState,
    isMultipart: false,
    dispatch,
  });

export const ManageClients =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      if (editMode) {
        bodyFormData.append("id", values?.id);
      }

      if (CheckDataIfExit(values?.first_name)) {
        bodyFormData.append("first_name", values?.first_name?.trim());
      } else {
        bodyFormData.append("first_name", "");
      }
      if (CheckDataIfExit(values?.last_name)) {
        bodyFormData.append("last_name", values?.last_name?.trim());
      } else {
        bodyFormData.append("last_name", "");
      }
      if (CheckDataIfExit(values?.email)) {
        bodyFormData.append("email", values?.email?.trim());
      } else {
        bodyFormData.append("email", "");
      }
      if (CheckDataIfExit(values?.password)) {
        bodyFormData.append("password", values?.password?.trim());
      } else {
        bodyFormData.append("password", "");
      }

      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        ChackImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode ? UrlApi.clients.edit : UrlApi.clients.add,
        // Our own words, never the server's.
        showalert: editMode ? "Customer details saved." : "Customer added. They can sign in now.",
        // A failure keeps the server's sentence only for a rule they can act
        // on ("This email is already used"); anything else is plain words.
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditClients =
  ({ callback, allData, quiet = false, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.clients.edit,
        // quiet: the page says what happened in its own words.
        showalert: !quiet,
        showerror: !quiet,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteClients =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idsclients: id,
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.clients.delete,
        showalert: id?.length > 1 ? `${id.length} customers deleted.` : "Customer deleted.",
        showerror: "Nothing was deleted. Try again.",
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
